var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('contents',{attrs:{"init-query":{type:'监督举报'},"content-data":_vm.contentData,"method-path":_vm.methodPath}})}
var staticRenderFns = []

export { render, staticRenderFns }